import { HashRouter, Route, Routes, Navigate } from 'react-router-dom'
import React, { Component, Suspense } from 'react'
import ApiService from 'src/services/apiservice';
import './scss/style.scss'

const loading = (
  <div className="pt-3 text-center">
    <div className="sk-spinner sk-spinner-pulse"></div>
  </div>
)

// Containers
const DefaultLayout = React.lazy(() => import('./layout/DefaultLayout'))

// Pages
const Login = React.lazy(() => import('./views/pages/login/Login'))
const Register = React.lazy(() => import('./views/pages/register/Register'))
const Page404 = React.lazy(() => import('./views/pages/page404/Page404'))
const Page500 = React.lazy(() => import('./views/pages/page500/Page500'))

class App extends Component {
  render() {
    const isAuthenticated = ApiService.getCookie('access_jwt') !== '';
    return (
      <HashRouter>
        <Suspense fallback={loading}>
          <Routes>
            <Route
              exact
              path="/login"
              name="Login Page"
              element={isAuthenticated ? <Navigate to="/dashboard" /> : <Login />}
            />
            <Route
              exact
              path="/register"
              name="Register Page"
              element={isAuthenticated ? <Navigate to="/dashboard" /> : <Register />}
            />
            <Route
              exact
              path="/404"
              name="Page 404"
              element={isAuthenticated ? <Navigate to="/dashboard" /> : <Page404 />}
            />
            <Route
              exact
              path="/500"
              name="Page 500"
              element={isAuthenticated ? <Navigate to="/dashboard" /> : <Page500 />}
            />
            <Route
              path="*"
              name="Home"
              element={isAuthenticated ? <DefaultLayout /> : <Navigate to="/login" />}
            />
          </Routes>
        </Suspense>
      </HashRouter>
    )
  }
}

export default App;
